import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import MailboxBrowserChild from "./MailboxBrowserChild";

const MailboxBrowser = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <MailboxBrowserChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default MailboxBrowser;
